import {Theme} from '@wellstone-solutions/common';
import {
  Box,
  Button,
  Link,
  Progress,
  Stack,
  TextField,
  Typography,
} from '@wellstone-solutions/web';
import {useNoteForm} from '../NoteForm';
import type {NarrativeAction, NarrativeState} from '../types';

type NarrativeSectionProps = {
  narrativeRequired: boolean;
  onSave: () => void;
};

export const NarrativeSection = ({
  narrativeRequired,
  onSave,
}: NarrativeSectionProps) => {
  const {state, dispatch, definition, progress, isSubmitting} = useNoteForm<
    NarrativeState,
    NarrativeAction
  >();
  const isEdited = state.narrative !== null;

  return (
    <Stack spacing={2}>
      <Stack spacing={1} alignItems="flex-start">
        <TextField
          fullWidth
          multiline
          minRows={6}
          required={narrativeRequired}
          label="Provider-reviewed final narrative"
          value={state.narrative ?? definition.composeNarrative(state)}
          helperText={
            isEdited
              ? "Edited - changes above won't update the narrative"
              : undefined
          }
          onChange={(event) =>
            dispatch({type: 'editNarrative', value: event.target.value})
          }
        />
        {isEdited && (
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={() => dispatch({type: 'resetNarrative'})}>
            Reset to generated narrative
          </Link>
        )}
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: 0.5,
          p: 1.5,
          borderRadius: 1,
          bgcolor: Theme.colorPalette.light,
        }}>
        <Typography variant="body2" fontWeight={700}>
          Saved in Bridge only.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This note won&apos;t be added to your EHR automatically.
        </Typography>
      </Box>
      <Stack direction="row" justifyContent="flex-end">
        <Button
          variant="contained"
          disabled={!progress.complete || isSubmitting}
          startIcon={
            isSubmitting ? (
              <Progress
                progressType="circular"
                size={16}
                sx={{color: 'inherit'}}
                aria-label="Saving"
              />
            ) : undefined
          }
          onClick={onSave}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
